var symphony = symphony || {};

;(function() {

	symphony.crossStorage = function() {

		CrossStorageHub.init([
			{origin: /\.example.com$/, allow: ['get', 'set', 'del']}
		]);

	};


})();